import React from "react";
import { RCCDateTimePicker } from "react-common-components";
import IDateTimePicker from "react-common-components/dist/components/DateTimePicker/interface";
import { useTranslation } from "src/context/Translations/context";


const DateTimePicker: React.FC<IDateTimePicker> = ({
	...rest
}) => {
	const {currentLanguage} = useTranslation();
	return(
		<RCCDateTimePicker 
			locale={currentLanguage}
			{...rest}	
		/>
	);
};

export default DateTimePicker;
